<template>
  <div class="input-text-container">
    <textarea :value="currentValue" @input="currentValue = $event.target.value"/>
    <span class="input-error" v-if="activate_required">{{$_('field_required')}}</span>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  data() {
    return {
      activate_required: false,
      currentValue: '',
    }
  },
  props: {
    required: {
      type: Boolean,
      default: false
    },
    val: {}
  },
  created() {
    if(this.$props.val !== undefined && this.$props.val !== '') {
      this.currentValue = this.$props.val
    }
  },
  computed: {
    getVal() {
      return this.$props.val
    }
  },
  watch: {
    currentValue(val) {
      this.$emit('typing', val); 
    },
    getVal(val) {
      this.currentValue = val
    }
  }
};
</script>

<style scoped>

</style>